const GermanFlag = () => (
  <svg
    width="16"
    height="12"
    viewBox="0 0 32 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="8" fill="#000000" />
    <rect y="8" width="32" height="8" fill="#DD0000" />
    <rect y="16" width="32" height="8" fill="#FFCE00" />
  </svg>
);

export default GermanFlag;
